"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Select = require("../../components/Select");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var getColor = function getColor(_ref) {
  var state = _ref.state,
    theme = _ref.theme;
  if (state.isDisabled) {
    return theme.colors.baseContrast050;
  }
  if (state.isSelected) {
    return theme.colors.baseContrast090;
  }
  return theme.colors.baseContrast085;
};
var getBorderColor = function getBorderColor(_ref2) {
  var state = _ref2.state,
    props = _ref2.props,
    theme = _ref2.theme;
  if (props.errorText) {
    return theme.colors.alert;
  }
  if (props.button === "flat") {
    return "transparent";
  }
  if (state.menuIsOpen || state.isFocused) {
    return theme.colors.baseContrast080;
  }
  return theme.colors.baseContrast040;
};
var getPlaceholderStyles = function getPlaceholderStyles(_ref3) {
  var state = _ref3.state,
    theme = _ref3.theme;
  if (state.isDisabled) {
    return theme.colors.baseContrast030;
  }
  return theme.colors.baseContrast050;
};
var getColorBytheme = function getColorBytheme(theme) {
  return theme.mode === "light" ? theme.colors.baseContrast080 : theme.colors.baseContrast060;
};
var Select = {
  styles: function styles(theme) {
    return {
      labelText: {
        color: theme.colors.baseContrast060,
        fontSize: _Select.selectVars.get("labelFontSize", "".concat(theme.typography.fontSize + 1, "px"))
      },
      lightBackground: {
        borderRadius: 6
      }
    };
  },
  select: {
    control: function control(_ref4) {
      var state = _ref4.state,
        props = _ref4.props,
        theme = _ref4.theme;
      return {
        borderColor: getBorderColor({
          state: state,
          props: props,
          theme: theme
        }),
        borderWidth: 1,
        borderRadius: 4,
        fontSize: theme.typography.fontSize + 2,
        color: theme.colors.baseContrast070,
        paddingInlineStart: theme.spacing.base * 1.5 - 1
      };
    },
    placeholder: function placeholder(_ref5) {
      var state = _ref5.state,
        theme = _ref5.theme;
      return {
        color: getPlaceholderStyles({
          state: state,
          theme: theme
        })
      };
    },
    dropdownIndicator: function dropdownIndicator(_ref6) {
      var state = _ref6.state,
        theme = _ref6.theme;
      return {
        "& svg": {
          fill: state.isDisabled ? theme.colors.baseContrast030 : getColorBytheme(theme)
        }
      };
    },
    menu: function menu(_ref7) {
      var theme = _ref7.theme;
      return {
        color: theme.colors.baseContrast085,
        borderRadius: 4,
        borderColor: theme.colors.baseContrast010
      };
    },
    option: function option(_ref8) {
      var theme = _ref8.theme,
        state = _ref8.state;
      return {
        paddingInlineStart: theme.spacing.base * 2,
        background: state.isSelected ? theme.colors.baseContrast015 : theme.colors.baseContrast010,
        color: getColor({
          state: state,
          theme: theme
        }),
        "&:hover, &:focus-visible": {
          borderColor: theme.colors.active,
          background: theme.colors.baseContrast020
        }
      };
    }
  }
};
var _default = exports.default = Select;